module.exports = __webpack_public_path__ + "img/ron_s.07580aa1.png";